import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import CountUp from "react-countup";

const textVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const statVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
};

const ExperienceSection = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
      {/* Main Light Beige Section */}
      <Box
        sx={{
          backgroundColor: "white", // Light beige
          color: "black", // Dark green text for contrast
          flex: 1,
          padding: { xs: 3, md: 6 },
        }}
      >
        <motion.div initial="hidden" animate="visible" variants={textVariants}>
         
        </motion.div>

        <motion.div initial="hidden" animate="visible" variants={textVariants}>
          <Typography variant="h3" sx={{ fontWeight: "bold" }}>
            Unispherexim
          </Typography>
        </motion.div>

        <motion.div initial="hidden" animate="visible" variants={textVariants}>
 <Typography variant="body1" sx={{ mt: 2, mb: 4 }}>
  <b>Unispherexim</b> is a forward-thinking startup specializing in the export of high-quality <b>onion-related products</b> including <b>white, pink, and red onions</b>, as well as <b>garlic</b>, <b>fried onions</b>, <b>vegetable powders</b>, and a wide range of <b>dehydrated vegetables</b>. Our mission is to establish a reliable and ethical global supply chain rooted in quality, sustainability, and trust.
  <br /><br />
  We collaborate closely with local farmers and skilled artisans to support fair trade practices, ensuring that each product reflects care, authenticity, and environmental responsibility.
  <br /><br />
  Through the use of advanced logistics and modern technology, we deliver freshness and consistency with every shipment, while actively working to reduce our ecological footprint.
  <br /><br />
  At Unispherexim, our commitment to customer satisfaction fuels every aspect of our operations, enabling us to build meaningful, long-term partnerships across the globe.
</Typography>
</motion.div>

        {/* Stats Section */}
        <Grid container spacing={4}>
          {/* {[
            { value: 50, label: "Countries We Export To" },
            { value: 1000, label: "Happy Clients Worldwide" },
            { value: 500, label: "Successful Shipments" },
          ].map((stat, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <motion.div initial="hidden" animate="visible" variants={statVariants}>
                <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                  <CountUp start={0} end={stat.value} duration={2} />+
                </Typography>
                <Typography variant="body2">{stat.label}</Typography>
              </motion.div>
            </Grid>
          ))} */}
        </Grid>
      </Box>

      {/* Sidebar with Vertical Text */}
      <Box
        sx={{
          backgroundColor: "#f1eddc", // Slightly darker beige
          width: { xs: "40px", md: "100px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          padding: 2,
        }}
      >
        <motion.div initial="hidden" animate="visible" variants={textVariants}>
          <Typography variant="body2" sx={{ fontWeight: "bold", color: "#1E3932" }}>
            Quality & Innovation in Every Shipment – Unispherexim
          </Typography>
        </motion.div>
      </Box>
    </Box>
  );
};

export default ExperienceSection;